// extracted by mini-css-extract-plugin
export default {"Skeleton":"Skeleton_Skeleton__oDqgg","skeleton-loading":"Skeleton_skeleton-loading__r-qMJ"};